import React, { createRef, forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { Form, Modal } from "reactstrap";
import Swal from 'sweetalert2';
import API from '../../../API';
import '../../../App.css';
import { Controller, useForm } from "react-hook-form";
import { KeyDownNumber, DateFormat, IdentifyTypeName, GetAPIURL, GetAuthorization, DateThai } from '../../../Utils/Function';
import { ThaiDatePicker } from "thaidatepicker-react";
import AsyncSelect from 'react-select/async';
import { SearchSubDistrict, SearchSchool } from '../../../Utils/Search';
import moment from 'moment';
import { PDFViewCard } from '../../../Components';
import parse from 'html-react-parser';

import ApplicationFormPDF from './ApplicationFormPDF';
const RegisterForm = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();
    const [_ModalFormState, setModalFormState] = useState(false);
    const [_ModalFileState, setModalFileState] = useState(false);
    const [_ModalPayment, setModalPayment] = useState(false);
    const [_ModalSubmit, setModalSubmit] = useState(false);

    const [_MemberID, setMemberID] = useState(null);
    const [_Application, setApplication] = useState(null);
    const [_ApplicationID, setApplicationID] = useState(null);
    const [_Project, setProject] = useState(null);
    const [_CourseList, setCourseList] = useState([]);
    const [_IdentifyType, setIdentifyType] = useState(1);
    const [_BirthDay, setBirthDay] = useState('');
    const [_Age, setAge] = useState('');

    const [_FileList, setFileList] = useState([]);
    const [_FormStep, setFormStep] = useState(1);

    const _FileInputRef = useRef();
    const _FilePaymentSlipRef = useRef();
    const [_FileRequestID, setFileRequestID] = useState(undefined);

    const [_PaymentStatus, setPaymentStatus] = useState(false);
    const [_PaymentSlipFile, setPaymentSlipFile] = useState(null);


    useEffect(() => {
        (async () => {

        })();

        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
        Show(ProjectID, ApplicationID) {
            setCourseList([]);
            setMemberID(null);
            setApplication(null);
            setApplicationID(null);
            _LoadProject(ProjectID);
        }
    }));
    const _Save = async () => {
        if (getValues('PrefixNameID') == null || getValues('PrefixNameID') == undefined || Number(getValues('PrefixNameID')) === 0) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุคำนำหน้าชื่อ'
            });
            return;
        }

        if (getValues('FirstName') == null || getValues('FirstName') == undefined || getValues('FirstName').length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุชื่อ'
            });
            return;
        }
        if (getValues('LastName') == null || getValues('LastName') == undefined || getValues('LastName').length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุนามสกุล'
            });
            return;
        }
        if (_BirthDay === undefined || _BirthDay === null) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุวันเดือนปีเกิด'
            });
            return;
        }
        if (getValues('Address') === null || getValues('Address') === undefined || getValues('Address').length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุที่อยู่ปัจจุบัน'
            });
            return;
        }
        if (getValues('Subdistrict') === null || getValues('Subdistrict') === undefined) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุที่ ตำบล / อำเภอ / จังหวัด'
            });
            return;
        }
        if (getValues('PostCode') == null || getValues('PostCode') == undefined || getValues('PostCode').length != 5) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุรหัสไปรษณีย์'
            });
            return;
        }

        if (getValues('Mobile') == null || getValues('Mobile') == undefined || getValues('Mobile').length < 9) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุหมายเลขโทรศัพท์นักเรียน'
            });
            return;
        }

        if (getValues('ParentMobile') == null || getValues('ParentMobile') == undefined || getValues('ParentMobile').length < 9) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุหมายเลขโทรศัพท์ผู้ปกครอง'
            });
            return;
        }

        if (getValues('ParentMobile') == null || getValues('ParentMobile') == undefined || getValues('ParentMobile').length < 9) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุหมายเลขโทรศัพท์ผู้ปกครอง'
            });
            return;
        }
        if (getValues('SchoolCode') === null || getValues('SchoolCode') === undefined) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุที่ โรงเรียน'
            });
            return;
        }
        if (_CourseList.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดเลือกหลักสูตรห้องเรียน'
            });
            return;
        }
        if (getValues('GPA') == null || getValues('GPA') == undefined || isNaN(Number(getValues('GPA'))) || Number(getValues('GPA')) <= 0) {
            Swal.fire({
                icon: 'error',
                title: 'โปรดระบุผลการเรียน'
            });
            return;
        }
        if (Number(getValues('GPA')) > 4) {
            Swal.fire({
                icon: 'error',
                title: 'รูปแบบผลการเรียนไม่ถูกต้อง'
            });
            return;
        }
        const _reqObj = {
            ApplicationID: (_ApplicationID === undefined ? null : _ApplicationID),
            MemberID: _MemberID,
            ProjectID: _Project.ProjectID,
            PrefixNameID: getValues('PrefixNameID'),
            FirstName: getValues('FirstName'),
            LastName: getValues('LastName'),
            BirthDay: _BirthDay,
            Age: _Age,
            IdentifyType: _IdentifyType,
            IdentifyID: getValues('IdentifyID'),
            Address: getValues('Address'),
            DistrictID: getValues('Subdistrict').SubdistrictID,
            PostCode: getValues('PostCode'),
            Mobile: getValues('Mobile'),
            ParentMobile: getValues('ParentMobile'),
            SchoolID: getValues('SchoolCode').SchoolID,
            GPAX: Number(getValues('GPA')),
            Course: _CourseList,
        }
        Swal.showLoading();
        API({ method: "post", url: "/Application/Save", data: _reqObj }).then(res => {
            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
                return;
            }
            if (res.data.Status) {
                console.log(res.data);
                setApplicationID(res.data.ApplicationID);
                const ApplicationID = res.data.ApplicationID;
                setModalFormState(false);
                Swal.fire({
                    title: res.data.Message,
                    html: 'โปรดรอสัครู่',
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(() => {

                    if (ApplicationID === null || ApplicationID === undefined) {
                        Swal.close();
                        _UpdateReload();
                        return;
                    }

                    API({ method: "get", url: "/Application/" + res.data.ApplicationID + '/File' }).then(res => {
                        setFileList(res.data);
                        setModalFileState(true);

                    }).catch(error => {
                        Swal.fire({
                            icon: 'error',
                            title: (error.response != undefined ? 'การทำงานผิดพลาด' : 'การเชื่อมต่อผิดพลาด'),
                            text: (error.response != undefined ? error.response.data.Message : error.message + ' [' + error.code + ']'),
                        });
                    });
                    Swal.close();
                    _UpdateReload();
                });
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                title: (error.response != undefined ? 'การทำงานผิดพลาด' : 'การเชื่อมต่อผิดพลาด'),
                text: (error.response != undefined ? error.response.data.Message : error.message + ' [' + error.code + ']'),
            });
        });
        //console.log(_reqObj);
        /*
         GPAEnglish : (getValues('GPAEnglish') != null ? Number(getValues('GPAEnglish')):0),
            GPAScience :(getValues('GPAScience') != null ? Number(getValues('GPAScience')):0),
            GPAMath : (getValues('GPAMath') != null ? Number(getValues('GPAMath')):0),
 FirstNameDad : getValues('FirstNameDad'),
            LastNameDad : getValues('LastNameDad'),
            AddressDad : getValues('AddressDad'),
            WorkDad : getValues('WorkDad'),
            PositionDad : getValues('PositionDad'),
            SalaryDad : (getValues('SalaryDad') != null ? Number(getValues('SalaryDad')):0),
            FirstNameMom : getValues('FirstNameMom'),
            LastNameMom : getValues('LastNameMom'),
            AddressMom : getValues('AddressMom'),
            WorkMom : getValues('WorkMom'),
            PositionMom : getValues('PositionMom'),
            SalaryMom : (getValues('SalaryMom') != null ? Number(getValues('SalaryMom')):0),
        */
    }

    const _LoadProject = async (ProjectID) => {
        API({ method: "get", url: "/Member/Project/" + ProjectID }).then(res => {
            if (res.data.Status) {
                setProject(res.data.Detail);
                if (res.data.Detail.Appliation != null) {
                    console.log(res.data.Detail.Appliation.ApplicationID);
                    setApplicationID(res.data.Detail.Appliation.ApplicationID);
                    _LoadApplicationForm(res.data.Detail.Appliation.ApplicationID);
                } else {
                    _LoadMember();
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
            }
        }).catch(error => {

        });
    }
    const _RegisterFileOpen = (FileRequest) => {
        setFileRequestID(FileRequest.FileRequetID);
        _FileInputRef.current.value = null;
        if (FileRequest.FileType === 1) {
            _FileInputRef.current.accept = ".png,.jpg,.jpe";
        } else {
            _FileInputRef.current.accept = ".png,.pdf,.jpg,.jpe";
        }
        _FileInputRef.current.click();
    }
    const _LoadMember = async () => {
        API({ method: "get", url: "/Member/Detail" }).then(res => {
            if (res.data.Status) {
                const _obj = res.data;
                setValue('PrefixNameID', _obj.PrefixID);
                setValue('FirstName', _obj.FirstName);
                setValue('LastName', _obj.LastName);
                setValue('IdentifyID', _obj.IdentifyID);
                setValue('Mobile', _obj.Mobile);
                setIdentifyType(_obj.IdentifyType);
                setBirthDay(_obj.BirthDay);
                setMemberID(_obj.MemberID);
                const AgeCal = moment().diff(Date.parse(_obj.BirthDay), 'years');
                if (!isNaN(AgeCal)) setAge(AgeCal); else setAge('');
                setModalFormState(true);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
            }
        }).catch(error => {

        });
    }
    const _DeleteFileAction = async (FileID) => {
        Swal.showLoading();
        API({ method: "delete", url: "/File/Application/" + FileID }).then(res => {
            _LoadApplicationFile(_ApplicationID);
            Swal.close();
        })
            .catch(error => {
                Swal.close();
                if (error.response != undefined) {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.data.Message
                    });

                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: error.message + ' [' + error.code + ']',
                    });
                }
            });
    }
    const _LoadApplicationFile = async (ApplicationID) => {

        API({ method: "get", url: "/Application/" + ApplicationID + '/File' }).then(res => {
            setFileList(res.data);
        }).catch(error => {

        });

    }

    const _ValidateApplication = async () => {
        Swal.showLoading();

        API({ method: "get", url: "/Application/" + _ApplicationID + '/Validate' }).then(res => {
            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
            }
            if (res.data.Status) {
                //_LoadApplicationForm(_ApplicationID);
                Swal.close();
                setModalFileState(false);
                setModalPayment(true);
            }
        }).catch(error => {
            Swal.close();
            if (error.response != undefined) {
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.Message
                });

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'การเชื่อมต่อผิดพลาด',
                    text: error.message + ' [' + error.code + ']',
                });
            }
        });
    }
    const _LoadApplicationForm = async (ApplicationID) => {
        API({ method: "get", url: "/Application/" + ApplicationID }).then(res => {
            if (res.data.Status) {
                const _obj = res.data;

                setMemberID(_obj.MemberID);
                setValue('PrefixNameID', _obj.PrefixNameID);
                setValue('FirstName', _obj.FirstName);
                setValue('LastName', _obj.LastName);
                setValue('IdentifyID', _obj.IdentifyID);
                setIdentifyType(_obj.IdentifyType);
                setBirthDay(_obj.BirthDay);
                setValue('Address', _obj.Address);
                setValue('Subdistrict', _obj.Subdistrict);
                setValue('PostCode', Number(_obj.PostCode));
                setValue('Mobile', _obj.Mobile);
                setValue('ParentMobile', _obj.ParentMobile);


                setValue('SchoolCode', _obj.SchoolCode);
                setValue('GPA', _obj.GPAX);
                setCourseList(_obj.Course);

                const AgeCal = moment().diff(_obj.BirthDay, 'years');
                if (!isNaN(AgeCal)) setAge(AgeCal); else setAge('');
                setApplication(_obj);
                if (!_ModalFormState) setModalFormState(true);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
            }
        }).catch(error => {

        });
    }

    const _Submit = async () => {
        Swal.showLoading();
        API({ method: "post", url: "/Application/" + _ApplicationID + '/Submit' }).then(res => {
            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
            }
            if (res.data.Status) {
                _UpdateReload();
                setModalPayment(false);
            }
            Swal.close();
        }).catch(error => {
            Swal.close();
            if (error.response != undefined) {
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.Message
                });

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'การเชื่อมต่อผิดพลาด',
                    text: error.message + ' [' + error.code + ']',
                });
            }
        });
    }

    const _UpdateReload = () => {
        if (props.reload != undefined) {
            try {
                props.reload();
            } catch (e) {
                console.log(e);
            }
        }
    }

    const _PaymentSlipUpload = async () => {
        const fd = new FormData();
        fd.append("File", _FilePaymentSlipRef.current.files[0]);
        Swal.showLoading();
        API({ method: "post", url: '/Application/' + _ApplicationID + '/Payment/Transfer', data: fd, headers: { "Content-Type": "multipart/form-data" } }).then(res => {
            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
                return;
            }
            setPaymentStatus(true);
            setModalPayment(false);
            Swal.fire({
                icon: 'success',
                title: 'ท่านได้กดยืนยันการชำระแล้ว',
                text: 'รอการตรวจสอบจากเจ้าหน้าที่เพื่อดำเนินการขั้นตอนต่อไป',
                timer: 10000,
                showCancelButton: false,
                showConfirmButton: false
            }).then(() => {
                _UpdateReload();
            });

        })
            .catch(error => {
                Swal.close();
                if (error.response != undefined) {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.data.Message
                    });

                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: error.message + ' [' + error.code + ']',
                    });
                }
            });
    }

    const _PaymentSlip = () => {
        _FilePaymentSlipRef.current.value = null;
        _FilePaymentSlipRef.current.click();
    }
    const _PaymentSlipFilePreview = (e) => {
        const _FileType = String(_FilePaymentSlipRef.current.files[0].type);
        if (!_FileType.includes('image/')) {
            Swal.fire({
                icon: 'error',
                title: 'รูปแบบไฟล์ไม่ถูกต้อง',
                text: 'โปรดเลือกไฟล์ประเภทรูปภาพ (PNG,JPEG)'
            });
            return;
        }
        const _URL = URL.createObjectURL(_FilePaymentSlipRef.current.files[0]);
        setPaymentSlipFile(_URL);
    }
    const _RegisterFileUpload = async (e) => {
        const FileRequestID = _FileRequestID;
        setFileRequestID(undefined);
        const fd = new FormData();
        fd.append("File", _FileInputRef.current.files[0]);
        Swal.showLoading();
        API({ method: "post", url: '/File/Application/' + _ApplicationID + '/' + _FileRequestID, data: fd, headers: { "Content-Type": "multipart/form-data" } }).then(res => {
            _LoadApplicationFile(_ApplicationID);
            Swal.close();
        })
            .catch(error => {
                console.log("Server Error : ", error);
                Swal.close();
            });

    }
    return (
        <>
            <Modal isOpen={_ModalFormState} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">แบบฟอร์มสมัครนักเรียน :: {(_Project != null ? _Project.ProjectName : "")}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setModalFormState(false) }}></button>
                </div>

                <div className='modal-body' style={{ minHeight: '300px' }}>
                    <div className='row mb-2'>
                        <div className='col-12 d-block d-sm-block d-md-none fw-semibold text-center'>{(_Application != null ? _Application.Name : "")}</div>
                        <div className='col-12 fs-5 d-none d-sm-none d-md-block fw-semibold text-center'>{(_Application != null ? _Application.Name : "")}</div>
                    </div>
                    <div className='row'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-2'>
                            <label className="form-label fw-semibold">คำนำหน้าชื่อ</label>
                            <Controller name="PrefixNameID" control={control} rules={{ required: false }} render={({ field }) => (
                                <select className='form-control' onChange={(e) => field.onChange(e)} value={field.value} defaultValue={field.value} >
                                    <option value={0}>เลือกคำนำหน้าชื่อ</option>
                                    <option value={1}>เด็กชาย</option>
                                    <option value={2}>เด็กหญิง</option>
                                    <option value={3}>นาย</option>
                                    <option value={4}>นางสาว</option>
                                </select>
                            )} />
                        </div>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-5'>
                            <label className="form-label fw-semibold">ชื่อ</label>
                            <input type="text" className="form-control" {...register("FirstName", { required: false })} autoComplete='one-time-code' />
                        </div>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-5'>
                            <label className="form-label fw-semibold">นามสกุล</label>
                            <input type="text" className="form-control" {...register("LastName", { required: false })} autoComplete='one-time-code' />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-3'>
                            <label className="form-label fw-semibold">วันเดือนปีเกิด</label>
                            <ThaiDatePicker maxDate={moment().add(-10, 'years').toDate()} inputProps={{ displayFormat: "D MMMM YYYY", className: 'text-center form-control' }} value={_BirthDay} onChange={(c, b) => {
                                if (c != null && c != undefined) {
                                    const AgeCal = moment().diff(c, 'years');
                                    if (!isNaN(AgeCal)) setAge(AgeCal); else setAge('');
                                }

                                setBirthDay(c);
                            }} />
                        </div>

                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-1'>
                            <label className="form-label fw-semibold">อายุ</label>
                            <input type="text" className="form-control text-center" value={_Age} readOnly={true} autoComplete='one-time-code' />
                        </div>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-4'>
                            <label className="form-label fw-semibold">{IdentifyTypeName(_IdentifyType)}</label>
                            <input type="text" className="form-control text-center" {...register("IdentifyID", { required: false })} readOnly={true} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-12'>
                            <label className="form-label fw-semibold">ที่อยู่ปัจจุบัน</label>
                            <Controller name="Address" control={control} rules={{ required: false }} render={({ field }) => (
                                <textarea className='form-control' value={field.value} onChange={(e) => field.onChange(e)}></textarea>
                            )} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-10'>
                            <label className="form-label fw-semibold">ตำบล / อำเภอ / จังหวัด</label>
                            <Controller name="Subdistrict" control={control} rules={{ required: false }} render={({ field }) => (
                                <AsyncSelect
                                    name={field.name}
                                    value={field.value}
                                    placeholder={'ค้นหา ตำบล / อำเภอ / จังหวัด'}
                                    loadOptions={(e) => SearchSubDistrict(e)}
                                    onChange={(e) => field.onChange(e)}
                                    getOptionLabel={(e) => e.FullName}
                                    getOptionValue={(e) => e.SubdistrictId} />
                            )} />
                        </div>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-2'>
                            <label className="form-label fw-semibold">รหัสไปรษณีย์</label>
                            <input type="text" maxLength={5} className="form-control text-center text-center" onKeyDown={KeyDownNumber} {...register("PostCode", { required: false })} autoComplete='one-time-code' />
                        </div>
                    </div>
                    <div className='row mt-4'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-6'>
                            <label className="form-label fw-semibold">หมายเลขโทรศัพท์นักเรียน</label>
                            <input type="tel" maxLength={10} className="form-control text-center text-center" onKeyDown={KeyDownNumber} {...register("Mobile", { required: false })} autoComplete='one-time-code' />
                        </div>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-6'>
                            <label className="form-label fw-semibold">หมายเลขโทรศัพท์ผู้ปกครอง</label>
                            <input type="tel" maxLength={10} className="form-control text-center text-center" onKeyDown={KeyDownNumber} {...register("ParentMobile", { required: false })} autoComplete='one-time-code' />
                        </div>
                    </div>
                    <div className='row mt-4'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-12'>
                            {(_Project != null && _Project.GradeLevel === 1 ? <label className="form-label fw-semibold">กำลังศึกษาชั้นประถมศึกษาปีที่ 6 โรงเรียน</label> : "")}
                            {(_Project != null && _Project.GradeLevel === 2 ? <label className="form-label fw-semibold">กำลังศึกษาชั้นมัธยมศึกษาปีที่ 3 โรงเรียน</label> : "")}
                            <Controller name="SchoolCode" control={control} rules={{ required: false }} render={({ field }) => (
                                <AsyncSelect
                                    name={field.name}
                                    value={field.value}
                                    placeholder={'ค้นหาชื่อโรงเรียน'}
                                    loadOptions={(e) => SearchSchool(e)}
                                    onChange={(e) => {
                                        field.onChange(e);
                                    }}
                                    getOptionLabel={(e) => e.FullName}
                                    getOptionValue={(e) => e.SchoolID} />
                            )} />
                        </div>
                    </div>
                    {(_Project != null ? <>
                        <div className='row mt-5'>
                            {(_Project != null && _Project.GradeLevel === 1 ?
                                <div className='col-lg-12 text-center fw-semibold'>ขอสมัครสอบคัดเลือกเข้า{_Project.ProjectName} โดยมีผลการเรียนเฉลี่ยสะสมชั้นประถมศึกษาปีที่ 4 และชั้นประถมศึกษาปีที่ 5  เท่ากับ</div>
                                : "")}
                            {(_Project != null && _Project.GradeLevel === 2 ?
                                <div className='col-lg-12 text-center fw-semibold'>ขอสมัครสอบคัดเลือกเข้า{_Project.ProjectName} โดยมีผลการเรียนเฉลี่ยสะสมชั้นมัธยมศึกษาปีที่ 1 ถึง ชั้นมัธยมศึกษาปีที่ 3 (5 ภาคเรียน) เท่ากับ</div>
                                : "")}
                        </div>
                        <div className='row justify-content-center'>
                            <div className='col-lg-2 pt-2 fw-semibold text-danger text-end'>เกรดเฉลี่ย (GPAX)</div>
                            <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-2'>
                                <input type="number" min={0} max={(4)} step={0.01} className="form-control text-center text-center" onKeyDown={KeyDownNumber} {...register("GPA", { required: false })} autoComplete='one-time-code' />
                            </div>
                        </div>
                    </> : "")}



                    <div className='row mt-4'>
                        <div className='mt-2 mb-2 col-xs-12 col-sm-12 col-lg-12'>
                            <label className="form-label fw-semibold">หลักสูตรห้องเรียน (ผู้สมัครสามารถเลือกได้ {(_Project != null ? _Project.CourseLimit : 0)} ลำดับ)</label>
                            {_Project != null ? Array.from({ length: _Project.CourseLimit }, (v, i) => i + 1).map((v, i) => (
                                <div className='row mt-4 mb-4'>
                                    <div className='col-2 fw-bold text-end'>ลำดับที่ {i + 1}</div>
                                    <div className='col-6'>
                                        <select className='form-control' onChange={(e) => {
                                            let _c = [..._CourseList];
                                            _c[i] = e.target.value
                                            setCourseList(_c);
                                        }} value={_CourseList[i] != undefined ? _CourseList[i] : 0} >
                                            <option value={0}>เลือกหลักสูตรห้องเรียน</option>
                                            {(_Project != null ? _Project.Courses.map((v, i) => (
                                                <option value={v.CourseID} key={i}>{v.Course.CourseName}</option>
                                            )) : "")}
                                        </select>
                                    </div>
                                </div>
                            )) : ""}
                        </div>
                    </div>
                    {(_Application != null && _Application.EditRemark != null ? <>
                        <div className='row justify-content-center'>
                            <div className='mt-2 mb-2 col-10 text-danger text-center fs-5 alert alert-danger'>
                                {parse(_Application.EditRemark)}
                            </div>
                        </div>
                    </> : '')}
                    <div className='row mt-4'>
                        <div className='col-12 text-center'>
                            <div className='btn-group btn-group-lg'>
                                <button type='button' className='btn btn-warning text-white' disabled={true}>ขั้นก่อนหน้า</button>
                                <button type='button' className='btn btn-success' onClick={(e) => { _Save() }}>ขั้นตอนถัดไป</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={_ModalFileState} className='modal-xl' centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">แนบเอกสารสมัคร :: {(_Project != null ? _Project.ProjectName : "")}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setModalFileState(false) }}></button>
                </div>
                <div className='modal-body' style={{ minHeight: '200px' }}>
                    {_FileList.map((v, i) => (
                        <>
                            <div className='row' key={i}>
                                <div className='col-lg-10 col-8 fw-semibold mt-3 mb-4'>{v.FileRequetName}</div>
                                <div className='col-lg-2 col-4 text-center mt-3 mb-4'><button type='button' className='btn btn-sm btn-success' disabled={(v.Limit > 0 && v.Files.length >= v.Limit ? true : false)} onClick={() => { _RegisterFileOpen(v); }}>เพิ่ม</button></div>
                            </div>
                            {v.Files.map((fv, fi) => (
                                <div key={fi}>
                                    <div className={(fv.CheckStatus === 2 ? 'row alert alert-danger' : 'row')}>
                                        <div className='col-lg-2 col-12 text-center mt-3 mb-3 '>
                                            <a href={GetAPIURL() + '/File/Application/' + GetAuthorization() + '/' + fv.FileID} target='_blank'>
                                                <img src={GetAPIURL() + '/File/Application/' + GetAuthorization() + '/' + fv.FileID + '/Preview'} style={{ 'maxHeight': '150px' }} />
                                            </a>

                                        </div>
                                        <div className='col-lg-8 col-12 text-center fw-semibold mt-3 mb-3'>{fv.FileName}</div>
                                        <div className='col-lg-2 col-12 text-center mt-3 mb-3'><button type='button' className='btn btn-sm btn-danger' onClick={(e) => { _DeleteFileAction(fv.FileID) }}>ลบ</button></div>
                                    </div>
                                    {(fv.CheckStatus != 0 ? <>
                                        <div className={(fv.VeriflyStatus === 2 ? 'row alert alert-danger' : 'row')}>
                                            <div className='col-lg-10 col-10 text-danger text-center fs-5'>
                                                <div className='mt-2'>{fv.VeriflyNote}</div>
                                            </div>
                                            <div className='col-lg-2 col-2 text-center'>
                                                {(fv.VeriflyStatus === 1 ?
                                                    <h5><span class="badge bg-info">ผ่าน</span></h5>
                                                    : '')}
                                                {(fv.VeriflyStatus === 2 ?
                                                    <h5><span class="badge bg-warning mt-4">แก้ไข</span></h5>
                                                    : '')}
                                            </div>
                                        </div>
                                    </> : '')}
                                </div>

                            ))}
                            <hr />
                        </>
                    ))}


                    <div className='row mt-4'>
                        <div className='col-12 text-center'>
                            <div className='btn-group btn-group-lg'>
                                <button type='button' className='btn btn-warning text-white' onClick={(e) => { setModalFileState(false); setModalFormState(true); }}>ขั้นก่อนหน้า</button>
                                <button type='button' className='btn btn-success' onClick={(e) => { _ValidateApplication(); }}>ขั้นตอนถัดไป</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={_ModalPayment} className='modal-xl' centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">
                        {(_Application != null && _Application.Payment ? 'ตรวจสอบข้อมูล' : 'ตรวจสอบข้อมูลและชำระค่าธรรมเนียมสมัครสอบ')} :: {(_Project != null ? _Project.ProjectName : "")}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setModalPayment(false) }}></button>
                </div>
                <div className='modal-body' style={{ minHeight: '300px' }}>
                    <div className='row'>
                        <div className='col-lg-8 col-12 mt-2 mb-2'>
                            <ApplicationFormPDF PDFFile={GetAPIURL() + '/Application/' + _ApplicationID + '/' + GetAuthorization() + '/PDF'} />
                        </div>
                        {(_Application != null && _Application.Payment ? <>
                            <div className='col-lg-4 col-12 fs-5 text-center'>
                                <button type='button' className='btn btn-danger' onClick={() => { _Submit() }}>ส่งใบสมัครสอบ</button>
                            </div>
                        </> : (_Application != null && _Application.PaymentSubmit > 0 ? <>
                            <div className='col-lg-4 col-12 fs-5 text-center text-danger'>ท่านได้กดยืนยันการชำระแล้ว  รอการตรวจสอบจากเจ้าหน้าที่เพื่อดำเนินการขั้นตอนต่อไป</div>
                        </> : <>
                            <div className='col-lg-4 col-12'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='card'>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-12 fw-semibold text-danger text-center fs-5'>
                                                        ค่าธรรมเนียมสมัครสอบ {(_Project != null ? _Project.Price : "0")} บาท
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-12 mt-4 mb-2 text-center'>
                                                        <div className='btn-group btn-lg'>
                                                            <h4 className='fw-semibold text-primary'>โอนเงิน ผ่านธนาคาร</h4>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mt-1 mb-1'>
                                                    <div className='col-12 fs-5 text-center'>
                                                        <img src={require('../../../Assets/Images/KTB.png')} />
                                                    </div>
                                                </div>
                                                <div className='row mt-1 '>
                                                    <div className='col-12 fs-5 text-center'>
                                                        ธนาคารกรุงไทย
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-12 fs-5 text-center'>
                                                        เลขที่บัญชี 521-1-47913-0
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-12 fs-5 text-center'>
                                                        ชื่อบัญชี วัฒโนทัยพายัพ (มสธ.)
                                                    </div>
                                                </div>
                                                {(!_PaymentStatus ? (_PaymentSlipFile != null ?
                                                    <>
                                                        <div className='row mt-5'>
                                                            <div className='col-12 text-center'>
                                                                <img src={_PaymentSlipFile} style={{ maxWidth: '300px' }} />
                                                            </div>
                                                        </div>
                                                        <div className='row mt-3'>
                                                            <div className='col-12 fs-5 text-center'>
                                                                <div className='btn-group btn-lg'>
                                                                    <button type='button' className='btn btn-success text-white' style={{ minWidth: '150px' }} onClick={() => { _PaymentSlipUpload() }}>ยืนยัน</button>
                                                                    <button type='button' className='btn btn-danger text-white' style={{ minWidth: '150px' }} onClick={() => { setPaymentSlipFile(null); }}>ยกเลิก</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className='row mt-5'>
                                                            <div className='col-12 fs-5 text-center'>
                                                                <button type='button' className='btn btn-danger' onClick={() => { _PaymentSlip() }}>แนบหลักฐานการโอนเงิน</button>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) :
                                                    <>
                                                        <div className='row mt-4 mb-4'>
                                                            <div className='col-12 fs-4 fw-semibold text-center text-success'>
                                                                เจ้าหน้าที่กำลังตรวจสอบ
                                                            </div>
                                                        </div>
                                                    </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>))}

                    </div>
                    <div className='row mt-4'>
                        <div className='col-12 text-center'>
                            <div className='btn-group btn-group-lg'>
                                <button type='button' className='btn btn-warning text-white' onClick={(e) => { setModalFileState(true); setModalPayment(false); }}>ขั้นก่อนหน้า</button>
                                <button type='button' className='btn btn-success' disabled={true}>ขั้นตอนถัดไป</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <input type='file' onChange={(e) => { _RegisterFileUpload(e) }} ref={_FileInputRef} style={{ display: 'none' }} accept=".png,.pdf,.jpg,.jpeg" />
            <input type='file' ref={_FilePaymentSlipRef} onChange={(e) => { _PaymentSlipFilePreview(e) }} style={{ display: 'none' }} accept=".png,.jpg,.jpeg" />
            <PDFViewCard ref={PDFViewCard} />
        </>)

});

export default React.memo(RegisterForm)